import {
    ADMINGETMAPPINGBANKLIST_SUCCESS,
    ADMINGETMAPPINGBANKLIST_FAILED,
    RESET_ADMINGETMAPPINGBANKLIST,
    LOADING_ADMINGETMAPPINGBANKLIST,
    NETWORK_ERROR_ADMINGETMAPPINGBANKLIST
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetMappingBankList = () => {
    return { type: RESET_ADMINGETMAPPINGBANKLIST };
};

const AdminGetMappingBankLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINGETMAPPINGBANKLIST });
    await adminServices
        .post("getMappingBankList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminGetMappingBankListsuccess(res.data));
                    break;
                default:
                    dispatch(adminGetMappingBankListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINGETMAPPINGBANKLIST,
                payload: err
            });
        });
};


function adminGetMappingBankListsuccess(data) {
    return {
        type: ADMINGETMAPPINGBANKLIST_SUCCESS,
        payload: data
    };
}
function adminGetMappingBankListFailed(data) {
    return {
        type: ADMINGETMAPPINGBANKLIST_FAILED,
        payload: data
    };
}

export { AdminGetMappingBankLists, resetAdminGetMappingBankList }